import { post, get, put, del } from '@/utils/request';

export const announce = () => get('/index/announce', {}, false)

export const roadList = () => get('/index/statistics/road', {}, false)

export const departList = () => get('/index/current/month/depart', {}, false)

export const orderList = () => get('/index/statistics/order', {}, false)


